import { render } from "./TableTitle.vue?vue&type=template&id=0c27b7d0"
import script from "./TableTitle.vue?vue&type=script&lang=js"
export * from "./TableTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__